import { IComponentOptions, IController, IScope } from 'angular';

import { AuthService } from './core/services/auth/auth.service';
import { UserService } from './core/services/user/user.service';
import './app.component.scss';
import { ToastrService } from './core/services/toastr/toastr.service';
import * as moment from 'moment-timezone';

class AppController implements IController {
  static $inject = [
    '$rootScope',
    'AuthService',
    'UserService',
    'ToastrService'
  ];

  constructor( private $rootScope: IScope,
               private authService: AuthService,
               private userService: UserService,
               private toastrService: ToastrService ) {
  }

  $onInit() {
    moment.tz.setDefault('UTC');
  }
}

export const AppComponent: IComponentOptions = {
  controller: AppController,
  template: require('./app.component.html')
};



// WEBPACK FOOTER //
// ./app/app.component.ts